import Breadcrumb from "components/Common/Breadcrumb";
import TableContainer from "components/Common/DataTableContainer";
import DashboardLoader from "components/Loader/DashboardLoader";
import DeleteModal from "pages/Calendar/DeleteModal";
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  useGetAllJobsQuery,
  useDeleteJobMutation,
} from "store/features/jobs/jobManagementApi";
import EditJobModal from "components/Modals/EditJobModal";

const AllJobs = () => {
  const { data: jobs, isLoading, refetch } = useGetAllJobsQuery();
  const [deleteJob, { isLoading: deletingJob }] = useDeleteJobMutation();

  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [categoryFilter, setCategoryFilter] = useState("");

  const showDeleteModal = id => {
    setSelectedJobId(id);
    setDeleteModal(true);
  };

  const handleDeleteJob = async () => {
    try {
      await deleteJob(selectedJobId).unwrap();
      refetch();
      setDeleteModal(false);
    } catch (error) {
      console.error("Failed to delete job:", error);
    }
  };

  const handleEditJob = job => {
    setSelectedJob(job);
    setEditModalOpen(true);
  };

  const handleJobUpdate = () => {
    refetch();
    setEditModalOpen(false);
  };

  // Filter jobs based on category
  const filteredJobs = useMemo(() => {
    if (!jobs) return [];

    return jobs.filter(job => {
      return !categoryFilter || job.jobcatagory === categoryFilter;
    });
  }, [jobs, categoryFilter]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getCategoryBadge = category => {
    const categoryConfig = {
      remote: { color: "success", text: "Remote" },
      onsite: { color: "primary", text: "On-site" },
      hybrid: { color: "warning", text: "Hybrid" },
      contract: { color: "info", text: "Contract" },
      internship: { color: "secondary", text: "Internship" },
    };
    const config = categoryConfig[category?.toLowerCase()] || { color: "warning", text: category || "N/A" };
    return `<span class="badge bg-${config.color}">${config.text}</span>`;
  };

  const getPositionBadge = position => {
    const positionConfig = {
      'full time permanent': { color: "success", text: "Full Time" },
      'internship': { color: "info", text: "Internship" },
      'contract': { color: "warning", text: "Contract" },
      'part time': { color: "warning", text: "Part Time" },
    };
    const config = positionConfig[position?.toLowerCase()] || { color: "warning", text: position || "N/A" };
    return `<span class="badge bg-${config.color}">${config.text}</span>`;
  };

  const columns = useMemo(
    () => [
      // {
      //   header: "ID",
      //   accessorKey: "id",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => `#${row.original.id}`,
      // },
      {
        header: "Title",
        accessorKey: "title",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div>
            <div className="">{row.original.title || "N/A"}</div>
            <small className="text-muted">{row.original.company || "N/A"}</small>
          </div>
        ),
      },
      // {
      //   header: "Position",
      //   accessorKey: "position",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => (
      //     <div
      //       dangerouslySetInnerHTML={{
      //         __html: getPositionBadge(row.original.position),
      //       }}
      //     />
      //   ),
      // },
      {
        header: "Category",
        accessorKey: "jobcatagory",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div
            dangerouslySetInnerHTML={{
              __html: getCategoryBadge(row.original.jobcatagory),
            }}
          />
        ),
      },
      // {
      //   header: "Location",
      //   accessorKey: "location",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => row.original.location || "N/A",
      // },
      // {
      //   header: "Duration",
      //   accessorKey: "duration",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => row.original.duration || "N/A",
      // },
      {
        header: "Posted Date",
        accessorKey: "date",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => formatDate(row.original.date),
      },
      // {
      //   header: "Likes",
      //   accessorKey: "likes",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => (
      //     <span className="badge bg-light text-dark">
      //       <i className="fas fa-heart text-danger me-1"></i>
      //       {row.original.likes || "0"}
      //     </span>
      //   ),
      // },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="d-flex align-items-center gap-1">
            <button
              onClick={() => handleEditJob(row.original)}
              className="btn btn-primary btn-sm"
            >
              <i className="fas fa-edit"></i>
            </button>
            <button
              className="btn btn-danger btn-sm"
              onClick={() => showDeleteModal(row.original.id)}
            >
              <i className="fas fa-trash"></i>
              {/* {deletingJob ? "Deleting..." : "Delete"} */}
            </button>
          </div>
        ),
      },
    ],
    [deletingJob]
  );

  if (isLoading) {
    return <DashboardLoader />;
  }

  return (
    <div className="page-content">
      <div className="container-fluid">

         <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
                 
                 {/* Breadcrumb Section */}
                 <div>
                   <Breadcrumb title="Jobs" breadcrumbItem="Jobs" />
                 </div>
               
                 {/* Action Buttons */}
                 <div className="d-flex flex-wrap gap-2">

  <Link
    to="/create-job"
    className="btn btn-primary d-flex align-items-center px-3 py-2 shadow-sm"
  >
    <i className="fas fa-briefcase me-2"></i>
    Create Job
  </Link>

  <Link
    to="/all-job-applications"
    className="btn btn-outline-primary d-flex align-items-center px-3 py-2 shadow-sm"
  >
    <i className="fas fa-users me-2"></i>
    Applicants
  </Link>

</div>
               </div>


        <TableContainer
          columns={columns}
          data={filteredJobs}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder="Search Jobs..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />

        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteJob}
          loader={deletingJob}
          onCloseClick={() => setDeleteModal(false)}
        />

        {selectedJob && (
          <EditJobModal
            isOpen={editModalOpen}
            toggle={() => setEditModalOpen(false)}
            job={selectedJob}
            onJobUpdate={handleJobUpdate}
          />
        )}
      </div>
    </div>
  );
};

export default AllJobs;